import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ConstantService } from '@app/_services/constant.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-res-rev-total-detail',
    templateUrl: './res-rev-total-detail.component.html',
    styleUrls: ['./res-rev-total-detail.component.css'],
    standalone: false
})
export class ResRevTotalDetailComponent implements OnInit, OnChanges {

	@Input() resRevenue: any = [];
	columns: any[];

	constructor(
		public constantService: ConstantService,
		public dynamicDialogRef: DynamicDialogRef,
		public dynamicDialogConfig: DynamicDialogConfig) { }

	ngOnInit(): void {
		if (this.dynamicDialogConfig.data) {

			// get the resRev
			this.resRevenue = this.dynamicDialogConfig.data.resRevenue;
		}
	}
	ngOnChanges(changes: SimpleChanges): void { }
}
